import office from '@/taskpane/officejs/office-wrapper'
import { IObserver } from '@/taskpane/common/observer-pattern'
import OfficeObservable from './office-observable'
import broadcastMessageToPortals from '../messages/broadcast-message-to-portals'
import CallbackArgs, { defaultCallbackArgs } from '../messages/callback-args'

export class EmailBodyObservable extends OfficeObservable<string> {
  public eventHandlerType = () => null
  public get = async () => office.body.get(false, null)
  public interval = 500
}

export default class EmailBodyObserver implements IObserver<string> {
  public update(data: string): void {
    const args: CallbackArgs = defaultCallbackArgs()
    args.body = data
    broadcastMessageToPortals('BodySubmitted', args)
  }
}
